import { html, TemplateResult } from 'lit';
import { monthAndYearForPropertyDataRequest, PropertyDataUpdateLatch } from '../../../api/get-calendar-data-for-house';
import { enhancedEcommerceAddToCart } from '../../../helpers/enhanced-ecommerce';
import { staticText } from '../../../static-text';
import { BookingRequest, Dispatcher } from '../../../types/booking-request';
import { WPHousePost } from '../../../types/wp-data';

export function houseListItem(
	state: BookingRequest,
	dispatch: Dispatcher,
	propertyDataUpdateLatch: PropertyDataUpdateLatch,
	post: WPHousePost
): TemplateResult {
	let selectLabel = staticText.select;
	const isSelected = ( state.bookingData.houseId === post.id );
	if ( isSelected ) {
		selectLabel = staticText.selected;
	}

	const clickHandler = () => {
		// If this house is already selected, no dispatch should be made.
		if ( isSelected ) {
			return;
		}

		const monthAndYear = monthAndYearForPropertyDataRequest( state.bookingData.startOfStay );
		propertyDataUpdateLatch.setInput( post.id, monthAndYear.year, monthAndYear.month );

		enhancedEcommerceAddToCart( post );

		dispatch( {
			type: 'UPDATE_HOUSE',
			houseId: post.id,
			houseTitle: post.title,
			maxPersons: post.booking.maxPersons,
		} );
	};

	return html`
		<li class="houses-overview__list-item">
			<h3 class="house-overview__title type-d">
				${post.title}
			</h3>

			<p class="house-overview__text type-g">
				${post.booking.description}
			</p>

			<div class="house-overview__actions">
				<a
					class="house-overview__actions__button button"
					href="${post.link}"
					target="_blank"
				>
					${staticText.info}
				</a>

				<button
					@click=${clickHandler}
					aria-pressed=${isSelected}
					class="house-overview__actions__button button"
				>
					${selectLabel}
				</button>
			</div>
		</li>
	`;
}
